module.exports = __webpack_public_path__ + "88196e6b1de2d8911c45cec19df9bd4f.png";